var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, } from "vue-property-decorator";
import { createPngImage, } from "./utilities/aux";
let HoverThumbnail = class HoverThumbnail extends Vue {
    get png() { return this.displayInfo.png === undefined ? undefined : createPngImage(this.displayInfo.png); }
    get svg() { return this.displayInfo.svg; }
    get showPng() { return this.png !== undefined; }
    get showSvg() { return !this.showPng && this.svg !== undefined; }
    mounted() {
        if (!this.showPng && !this.showSvg) {
            throw Error("At least one picture for the thumbnail has to exist");
        }
        if (this.showSvg) {
            {
                const s = this.$el.querySelector(".svgPicture");
                if (s === undefined || s === null) {
                    throw Error("Selector '.svgPicture' does not match");
                }
                s.appendChild((new DOMParser())
                    .parseFromString(this.svg, "image/svg+xml").documentElement);
            }
            {
                const s = this.$el.querySelector(".svgHover");
                if (s === undefined || s === null) {
                    throw Error("Selector '.svgHover' does not match");
                }
                s.appendChild((new DOMParser())
                    .parseFromString(this.svg, "image/svg+xml").documentElement);
            }
        }
    }
};
__decorate([
    Prop({ required: true })
], HoverThumbnail.prototype, "displayInfo", void 0);
HoverThumbnail = __decorate([
    Component({
        name: "HoverThumbnail",
    })
], HoverThumbnail);
export default HoverThumbnail;
